<template>

    <m-edit1/>

    <m-dashboard-layout-2 v-bind='{...{"menuPosition":"store_nav","sideBar":"col-lg-3","contentWrapper":"col-lg-9"},...{}}' :style='""' class="m-2" >
                <template #p-2>   <m-h5 v-bind='{...{},...{}}' :style='"font-size: 13px;\n"' class="my-3 border-bottom pb-2" >
                <template #default>ساخت وقت دهی   </template>
                </m-h5><m-div v-bind='{...{},...{}}' :style='""' class="container" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="col-lg-12 text-center m-0 p-0 pb-5 mb-5 " >
                <template #default>   <m-copy-1 v-bind='{...{"itemId":17,"itemType":"product","iconName":""},...{}}' :style='""' class="d-inline-block" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="col-12" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='"border-radius:15px;\ntransition: all 0.2s ease-in-out;\n"' class="w-100 text-center  shadow card-header " >
                <template #default>   <m-img v-bind='{...{"src":"https:\/\/api.vokaladezful.com\/storage\/menu\/Rmv8QbpqRtxJBfnQXwx2e1iPiH3d8clSi9FfRN7T.png","alt":"vokala"},...{}}' :style='"border-radius:15px;\naspect-ratio:1\/1;\nobject-fit:contain;\nheight:100px\n"' class="img-fluid" ></m-img><m-h4 v-bind='{...{},...{}}' :style='"\n\n"' class="text-primary h6 mt-3" >
                <template #default>ساخت وقت دهی   </template>
                </m-h4></template>
                </m-div></template>
                </m-div></template>
                </m-copy-1></template>
                </m-div></template>
                </m-div></template>
                </m-dashboard-layout-2>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mDashboardLayout2 from '@moeinmdn/miw-alpha-components/src/package/DashboardLayout/DashboardLayout2'; import mH5 from '@moeinmdn/miw-alpha-components/src/package/Tags/H5'; import mDiv from '@moeinmdn/miw-alpha-components/src/package/Tags/Div'; import mCopy1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Copy/Copy1'; import mImg from '@moeinmdn/miw-alpha-components/src/package/Tags/Img'; import mH4 from '@moeinmdn/miw-alpha-components/src/package/Tags/H4';

export default {
    name: 'HomeView',
    components: {mEdit1, mDashboardLayout2,mH5,mDiv,mCopy1,mImg,mH4 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
